// extracted by mini-css-extract-plugin
export default {"mySkills":"MySkills_mySkills__+nMuM","innerWrapper":"MySkills_innerWrapper__cVgPT","canvasWrapper":"MySkills_canvasWrapper__Bw1i4"};